import * as React from 'react';
import { FC } from 'react';

import { ProductImg } from 'components/recent-order-card/styled';
import { AbsoluteBackgroundImage } from 'enums/absolute-background-image';

import {
  AddItemBtn,
  Details,
  ExclamationIcon,
  ItemImage,
  ItemName,
  Modifier,
  NotAvailableText,
  UnavailableText,
  Wrapper,
} from './recent-order-card-with-modifiers.styled';
import { IRecentOrderCardWithModifiersViewProps } from './types';

export const RecentOrderCardWithModifiersView: FC<IRecentOrderCardWithModifiersViewProps> = ({
  name,
  productImage,
  backgroundImage,
  modifiers,
  handleAddClick,
  isAvailable,
  unavailableMessage,
  addButtonText,
  buildImageUrl,
  ariaLabel,
}) => (
  <Wrapper>
    <ItemImage
      data-testId="recent-item-with-modifier-image"
      height="104px"
      backgroundImageUrl={
        backgroundImage && backgroundImage.asset
          ? buildImageUrl(backgroundImage, {
              width: AbsoluteBackgroundImage.WIDTH,
              height: AbsoluteBackgroundImage.HEIGHT,
              format: 'jpg',
            })
          : ''
      }
    >
      <ProductImg image={productImage} alt={name} />
    </ItemImage>
    <Details>
      <ItemName data-testId="recent-item-with-modifier-item-name">{name}</ItemName>
      <div data-testId="recent-item-with-modifier-modifiers-wrapper">
        {modifiers.map(modifier => (
          <Modifier key={modifier}>{modifier}</Modifier>
        ))}
      </div>
    </Details>
    {isAvailable ? (
      <AddItemBtn
        onClick={handleAddClick}
        data-testId="recent-item-with-modifier-add-btn"
        aria-label={ariaLabel}
      >
        {`+ ${addButtonText}`}
      </AddItemBtn>
    ) : (
      <NotAvailableText data-testId="recent-item-with-modifier-unavailable-wrapper">
        <ExclamationIcon>!</ExclamationIcon>
        <UnavailableText>{unavailableMessage}</UnavailableText>
      </NotAvailableText>
    )}
  </Wrapper>
);
